// extracted by mini-css-extract-plugin
module.exports = {"heading":"Accordion_heading__T8wUZ","content":"Accordion_content__K8u9N"};